import { firstVisible, whenElementVisible, escapeHtml, accentedHtml, dropStaleHighlights, collapsedTarget, revealPanelFor, openPanelIds, restorePanels } from './helpers';

// Spotlights each sidebar item in turn; opens the accordions to reach the links and puts them back on the
// way out. Copy, order and captures come from ToursHelper#sidebar_tour_payload. Mounted manually by the
// sidebar component, so it only runs from the sidebar's "?".

const navSelector = (nav) => `[data-tour-nav="${nav}"]`;
// Written in full: driver.js takes a step's popoverClass over the config-level one.
const CAPTURE_POPOVER = 'unscreen-tour-popover unscreen-tour-popover--capture';
// tours.scss holds the box at the capture's ratio, so the popover is at its final size before the image lands.
const captureHtml = (capture) => `<img class="tour-capture" src="${escapeHtml(capture.src)}" srcset="${escapeHtml(capture.srcset)}" alt="" loading="lazy" decoding="async">`;

// Only copy under a capture needs its own paragraph; on its own the title carries the spacing.
const descriptionHtml = ({ description, capture }) => (capture ? `${captureHtml(capture)}<p class="tour-text">${accentedHtml(description)}</p>` : accentedHtml(description));

export default {
  mount({ start, payload }) {
    const steps = payload.steps || [];
    if (!steps.length) return undefined;

    let openOnArrival = new Set();
    const cleanups = [];

    const resolve = (nav) => firstVisible(navSelector(nav)) ?? collapsedTarget(navSelector(nav));

    const restoreAccordions = () => restorePanels(openOnArrival);

    const stepFor = (step) => ({
      // A function, not a node: sidebar and mobile nav share the key, and which is visible depends on the
      // viewport when the step renders.
      element: () => resolve(step.nav),
      popover: {
        title: escapeHtml(step.title),
        description: descriptionHtml(step),
        side: 'right',
        align: 'start',
        ...(step.capture ? { popoverClass: CAPTURE_POPOVER } : {}),
      },
      onHighlightStarted: (element) => {
        dropStaleHighlights(element);
        revealPanelFor(element);
      },
    });

    // Filtered up front: driver.js centres a step whose element resolves null, leaving copy about a menu item
    // this visitor hasn't got.
    const begin = () => {
      const present = steps.filter(({ nav }) => resolve(nav));
      if (!present.length) return;

      openOnArrival = openPanelIds();
      start({ steps: present.map(stepFor), onDestroyed: restoreAccordions });
    };

    cleanups.push(whenElementVisible(steps.map(({ nav }) => navSelector(nav)).join(', '), begin));

    return () => cleanups.forEach((cleanup) => cleanup());
  },
};
